export default "__VITE_ASSET__7fvjxlUK__"